import React from 'react';
import { Text } from '@react-three/drei';

function SolarPanel({ position, size, onHover, component, onClick }) {
  const [width, height, depth] = size;
  return (
    <group position={position}>
      <mesh
        onPointerOver={() => onHover(component.name)}
        onPointerOut={() => onHover(null)}
        onClick={() => onClick(component)}
        castShadow
        receiveShadow
      >
        <boxGeometry args={[width, height, depth]} />
        <meshLambertMaterial color='#1e3a8a' />
      </mesh>

      {Array.from({ length: 6 }).map((_, i) => (
        <mesh
          key={i}
          position={[
            -width / 2 + width / 12 + (i * width) / 6,
            0,
            depth / 2 + 0.02,
          ]}
        >
          <meshLambertMaterial color='#1e40af' />
        </mesh>
      ))}

      {/* <Text
        position={[0, height / 1.2 + 0.7, 0]}
        fontSize={1.2}
        color='black'
        anchorX='center'
        anchorY='middle'
        outlineColor='#000000ff'
        outlineWidth={0.01}
        fontWeight={700}
      >
        {component.name}
      </Text> */}

      <group position={[-3.5, height + 3, 0]}>
        {/* First line - BIG FONT */}
        <Text
          fontSize={1.3}
          color='black'
          anchorX='left'
          anchorY='bottom'
          outlineColor='#000000ff'
          fontWeight={700}
        >
          {component.name}
        </Text>

        {/* Next 2 lines - SMALL FONT only if value exists */}
        {(component.details?.Brand_name ||
          component.details?.Quantity ||
          component.details?.Specification) && (
          <Text fontSize={0.9} color='black' anchorX='left' anchorY='top'>
            {`${component.details?.Brand_name || ''}\nx${component.details?.Quantity || '0'}\n${component.details?.Specification || ''}`}
          </Text>
        )}
      </group>
    </group>
  );
}

export default SolarPanel;
